import { Timestamp } from 'modules/Monitoring/types'

export function getStartOfDay(date: Date | Timestamp, returnDate?: false | never): number
export function getStartOfDay(date: Date | Timestamp, returnDate: true): Date
export function getStartOfDay(date: Date | Timestamp, returnDate = false) {
  const newDate = new Date(date)

  newDate.setHours(0, 0, 0, 0)

  return returnDate ? newDate : newDate.getTime()
}
